<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label" />
    <lib-signal-text-field
      label="Help text"
      placeholder="Shown under the field"
      [formField]="configForm.helpText" />
    <lib-signal-dropdown
      label="Currency"
      placeholder="Select the currency type"
      [items]="currencyOptions"
      valuePath="value"
      displayPath="label"
      [formField]="configForm.currency" />
    <lib-signal-number-field
      label="Default amount"
      placeholder="Enter the default amount"
      [formField]="configForm.defaultAmount" />
  </section>

  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Validators
    </h3>
    <div class="grid gap-3 sm:grid-cols-2">
      <lib-signal-number-field
        label="Minimum amount"
        [placeholder]="'e.g., 10'"
        [formField]="configForm.min" />
      <lib-signal-number-field
        label="Maximum amount"
        [placeholder]="'e.g., 100'"
        [formField]="configForm.max" />
    </div>
    <lib-signal-checkbox
      label="Required"
      [formField]="configForm.required" />
    <lib-signal-checkbox
      label="Disabled"
      hint="Field is shown but cannot be changed"
      [formField]="configForm.disabled" />
  </section>
</form>
